export default "__VITE_ASSET__095caf3b__"